import { Link as RouterLink, LinkProps } from "react-router-dom";
import { useMemo } from "react";
import { useLanguage } from "@/hooks/useLanguage";

/**
 * Link component that automatically prepends language prefix to paths
 */
export function LocalizedLink({ to, ...props }: LinkProps) {
  const { language } = useLanguage();

  // Add language prefix to the path if it doesn't already have one
  const pathWithLang = useMemo(() => {
    if (!to || typeof to !== "string") return to;

    // If path already starts with a language prefix, return as is
    if (to.match(/^\/(cs|en)(\/|$)/)) {
      return to;
    }

    // If path is root, return language prefix
    if (to === "/") {
      return `/${language}`;
    }

    // Otherwise, prepend language prefix
    return `/${language}${to.startsWith("/") ? to : `/${to}`}`;
  }, [to, language]);

  return <RouterLink to={pathWithLang} {...props} />;
}
